<template>
  <router-view></router-view>
</template>
<script>
import RegisterStoreModule from '@/mixins/RegisterStoreModule'
import commentStore from './store.js'

export default {
  name: 'comment',
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule('comment', commentStore)
  },
}
</script>
